export default __webpack_public_path__ + "static/media/logo.21e2cc7b.png";